import { db } from '../config/firebase';
import { doc, getDoc, setDoc } from 'firebase/firestore';

export interface TeamMember {
  email: string;
  name: string;
  dateAdded: string;
}

export interface Team {
  members: TeamMember[];
  lastUpdated: string;
}

const COLLECTION_NAME = 'teams';

export const teamService = {
  async getTeam(userEmail: string | null): Promise<Team | null> {
    if (!userEmail) {
      
      return null;
    }

    try {
      const teamDoc = await getDoc(doc(db, COLLECTION_NAME, userEmail));
      if (teamDoc.exists()) {
        return teamDoc.data() as Team;
      }
      return null;
    } catch (error) {
      
      throw error;
    }
  },

  async updateTeam(userEmail: string | null, team: Team | null): Promise<void> {
    if (!userEmail) {
      
      return;
    }
    if (!team) {
      
      return;
    }

    try {
      await setDoc(doc(db, COLLECTION_NAME, userEmail), team);
    } catch (error) {
      
      throw error;
    }
  },

  async addTeamMember(userEmail: string | null, member: TeamMember | null): Promise<void> {
    if (!userEmail) {
      
      return;
    }
    if (!member) {
      
      return;
    }

    try {
      const team = await this.getTeam(userEmail);
      const newTeam: Team = {
        members: [...(team?.members || []), member],
        lastUpdated: new Date().toISOString()
      };
      await this.updateTeam(userEmail, newTeam);
    } catch (error) {
      
      throw error;
    }
  },

  async removeTeamMember(userEmail: string | null, memberEmail: string | null): Promise<void> {
    if (!userEmail) {
      
      return;
    }
    if (!memberEmail) {
      
      return;
    }

    try {
      const team = await this.getTeam(userEmail);
      if (team) {
        const newTeam: Team = {
          members: team.members.filter(m => m.email !== memberEmail),
          lastUpdated: new Date().toISOString()
        };
        await this.updateTeam(userEmail, newTeam);
      }
    } catch (error) {
      
      throw error;
    }
  }
};
